// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".geo-modal[data-v-4bc57e38]{width:500px}", ""]);
// Exports
module.exports = exports;
